import { render, staticRenderFns } from "./prod_detail.vue?vue&type=template&id=2b1efa40&scoped=true"
import script from "./prod_detail.vue?vue&type=script&lang=js"
export * from "./prod_detail.vue?vue&type=script&lang=js"
import style0 from "./prod_detail.vue?vue&type=style&index=0&id=2b1efa40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1efa40",
  null
  
)

export default component.exports